import { MainCard, MainCardTitle, MainCardContent } from "src/components/main-card-type.tsx"
import { useIsVerified } from "src/components/email-verification";
import { Button } from "src/components/ui/button";
import {
    checkCalculatorUsageLimitAndRedirect,
    loadSavedCalculatorData,
    sanitizeBrlValue,
    saveCalculatorData,
} from "src/utils/functions";
import { useEffect, useState } from "react";
import { calcularINSS, calcularIRRF } from "../utils/FeriasFunctions";
import { ResponseSalario } from "../Ferias";

export const FeriasInputCard = ({
    setResults,
}: {
    setResults: (value: ResponseSalario | null) => void;
}) => {
    const [message, setMessage] = useState<string>("");

    const [valorBruto, setValorBruto] = useState("")
    const [diasFerias, setDiasFerias] = useState("")
    const [horas, setHoras] = useState("")
    const [dependentes, setDependentes] = useState("")
    const [abono, setAbono] = useState("nao")
    const [adiarparcela, setAdiarParcela] = useState("nao")
    const calculatorKey = "salario-ferias";

    function handleSave() {
        saveCalculatorData(calculatorKey, {
            valorBruto,
            diasFerias,
            horas,
            dependentes,
        });
    }


    function clear() {
        setValorBruto("");
        setDiasFerias("")
        setHoras("");
        setAbono("nao")
        setAdiarParcela("nao")

    }
    useEffect(() => {
        const savedData = loadSavedCalculatorData(calculatorKey);
        if (!savedData) return;

        setValorBruto((savedData.valorBruto as string) || "");
        setDiasFerias((savedData.diasFerias as string) || "");
        setHoras((savedData.horas as string) || "")
        setDependentes((savedData.dependentes as string) || "");
        setAbono((savedData.abono as string) || "nao")
        setAdiarParcela((savedData.adiarparcela as string) || "nao")
    }, []);

    const isVerified = useIsVerified();

    function calculo() {
        if (!valorBruto || valorBruto === "0,00") {
            setMessage("Por favor adicione um valor ao Salario Bruto.");
            setResults(null)
            return;
        }
        if (!diasFerias || diasFerias === "0") {
            setMessage("Por favor adicione uma quantidade de dias ")
            setResults(null)
            return
        }
        if (!dependentes) {
            setMessage("Por favor adicione um valor ao Número de Dependentes");

            setResults(null)
            return;
        }
        setMessage("");

        const SalarioBruto = Number.parseFloat(
            valorBruto.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        const Dias = Number.parseFloat(
            diasFerias.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        const ValorDependente = Number.parseFloat(
            dependentes.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        const Valorhoras = Number.parseFloat(
            horas.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );

        let ValorFerias: number = 0
        let Umterço: number = 0
        let totais: number = 0
        let ValorINSS: number = 0
        let ValorIRFF: number = 0
        let PorcentagemINSS: number = 0
        let PorcentagemIRRF: number = 0
        let valorfinal: number = 0
        let ValorAbono: number = 0
        let UmterçoAbono: number = 0
        let decimoterceiro: number = 0

        let valorInicial = (SalarioBruto + Valorhoras) * (Dias / 30)
        ValorFerias = Math.round(valorInicial * 100) / 100

        Umterço = Math.round((valorInicial / 3) * 100) / 100
        valorInicial = valorInicial + Umterço

        totais = Math.round(valorInicial * 100) / 100

        let inss = calcularINSS(valorInicial)
        ValorINSS = inss.valor
        console.log(inss.aliquotaEfetiva, "INSS");

        PorcentagemINSS = inss.aliquotaEfetiva
        let irff = calcularIRRF(valorInicial, inss.valor, ValorDependente)
        ValorIRFF = irff.valor
        PorcentagemIRRF = irff.aliquota
        console.log(ValorIRFF, "IRRF");
        valorInicial = valorInicial - inss.valor - irff.valor
        valorInicial = Math.round(valorInicial)
        valorfinal = valorInicial
        console.log(valorfinal, "Valor Final");


        switch (abono) {
            case "nao":
                switch (adiarparcela) {
                    case "sim":
                        decimoterceiro = SalarioBruto / 2
                        totais = totais + decimoterceiro
                        break
                }
                break;
            case "sim":
                let baseferias = valorInicial + Umterço

                let DiasVendidos = 10

                ValorAbono = ((SalarioBruto + Valorhoras) / 30) * DiasVendidos

                UmterçoAbono = ValorAbono / 3

                totais = Math.round((ValorFerias + Umterço + ValorAbono + UmterçoAbono) * 100) / 100


                inss = calcularINSS(totais)
                ValorINSS = inss.valor
                PorcentagemINSS = inss.aliquotaEfetiva


                let inssFerias = (baseferias / totais) * inss.valor
                irff = calcularIRRF(baseferias, inssFerias, ValorDependente)
                ValorIRFF = irff.valor
                PorcentagemIRRF = irff.aliquota


                switch (adiarparcela) {
                    case "sim":
                        decimoterceiro = SalarioBruto / 2
                        totais = totais + decimoterceiro
                        break
                }

                valorfinal = Math.round((totais - inss.valor - irff.valor) * 100) / 100
                console.log(ValorIRFF, "IRRF");
                break;
        }

        const resultado = {
            valorfinal: valorfinal,
            ValorFerias: ValorFerias,
            Umterço: Umterço,
            totais: totais,
            ValorINSS: ValorINSS,
            ValorIRFF: ValorIRFF,
            PorcentagemINSS: PorcentagemINSS,
            ValorAbono: ValorAbono,
            UmterçoAbono: UmterçoAbono,
            decimoterceiro: decimoterceiro,
            PorcentagemIRRF: PorcentagemIRRF
        }
        setResults(resultado);
    }

    return (
        <MainCard>
            <MainCardTitle>Calculadora de Férias</MainCardTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSave();
                    checkCalculatorUsageLimitAndRedirect(calculo);
                }}
            >
                <MainCardContent>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">
                            Salario Bruto *
                        </label>
                        <div className="flex border">
                            <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                                R$
                            </span>
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="campo-id"
                                placeholder="00,00"
                                type="text"
                                value={valorBruto}
                                onChange={(event) => setValorBruto(sanitizeBrlValue(event))}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">
                            Dias de Férias *
                        </label>
                        <div className="flex border">

                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="campo-id"
                                placeholder="0"
                                type="text"
                                value={diasFerias}
                                onChange={(event) => setDiasFerias(event.target.value)}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">
                            Horas extras (se houver)
                        </label>
                        <div className="flex border">
                            <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                                R$
                            </span>
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="campo-id"
                                placeholder="00,00"
                                type="text"
                                value={horas}
                                onChange={(event) => setHoras(sanitizeBrlValue(event))}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">
                            Numero De Dependentes

                        </label>
                        <div className="flex border">

                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="campo-id"
                                placeholder="0"
                                type="text"
                                value={dependentes}
                                onChange={(event) => setDependentes(event.target.value)}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">

                          Abono pecuniario

                        </label>
                        <div className="flex border">
                            <select name="" id="" value={abono}
                                onChange={(event) =>
                                    setAbono(event.target.value)
                                }
                                className="flex-1 p-2 min-w-[100px]">
                                <option value="nao">Não</option>
                                <option value="sim">Sim</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">
                            Adiantar 1ª parcela 13º:
                        </label>
                        <div className="flex border">
                            <select name="" id="" value={adiarparcela}
                                onChange={(event) => setAdiarParcela(event.target.value)}
                                className="flex-1 p-2 min-w-[100px]">
                                <option value="nao">Não</option>
                                <option value="sim">Sim</option>
                            </select>
                        </div>
                    </div>

                </MainCardContent>

                <div className="flex justify-between">
                    <Button
                        disabled={!isVerified}
                        type="submit"
                        variant={"default"}
                        className="sm:w-[150px]"
                    >
                        Calcular
                    </Button>

                    <div className="flex flex-col sm:flex-row items-center gap-2">
                        <a
                            href="/calculadoras/ferias-proporcional"
                            className="text-md text-primary text-center "
                        >
                            Ir para calculadora de Ferias Proporcional
                        </a>
                        <Button onClick={clear} variant={"ghost"}>
                            Limpar
                        </Button>
                    </div>
                </div>
            </form>

            <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
        </MainCard >

    )
}